module.exports = __webpack_public_path__ + "static/media/eraseInstance.251cba5e.md";